import React, { useState } from "react";
import {
  User,
  Menu,
  X,
  Heart,
  History as HistoryIcon,
  LogOut,
  LayoutDashboard,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  // Check if staff is authenticated
  const isAuthenticated =
    localStorage.getItem("isStaffAuthenticated") === "true";

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleNav = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("isStaffAuthenticated");
    setIsOpen(false);
    navigate("/");
  };

  return (
    <nav className="bg-white/95 backdrop-blur-md sticky top-0 z-50 border-b border-orange-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center">
        {/* Logo Section */}
        <div
          onClick={() => handleNav("/")}
          className="flex items-center gap-3 hover:cursor-pointer"
        >
          <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center shadow-orange-200 shadow-lg overflow-hidden">
            <img
              src="/icon.png"
              alt="Temple Icon"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="flex flex-col">
            <span className="text-sm md:text-lg font-bold tracking-tight text-orange-900 leading-none">
              Sri Bramhasutra Marakatha Shivalingam
            </span>
            <span className="text-[10px] md:text-xs text-orange-700 font-medium uppercase tracking-widest">
              Chandippa, Shankarpalli
            </span>
          </div>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8 text-sm font-semibold text-stone-700">
          <button
            onClick={() => navigate("/donations")}
            className="hover:text-orange-600 transition-colors"
          >
            Donations
          </button>

          <button
            onClick={() => navigate("/about-us")}
            className="hover:text-orange-600 transition-colors"
          >
            History
          </button>

          {/* Conditional Dashboard and Logout Logic: Desktop */}
          {isAuthenticated ? (
            <div className="flex items-center gap-6">
              {/* <button
                onClick={() => navigate("/dashboard/download")}
                className="hover:text-orange-600 transition-colors"
              >
                Download
              </button> */}
              {/* Dashboard in the middle */}
              <button
                onClick={() => navigate("/dashboard")}
                className="hover:text-orange-600 transition-colors"
              >
                Dashboard
              </button>

              <button
                onClick={handleLogout}
                className="flex items-center gap-2 bg-orange-700 hover:bg-orange-800 text-white px-5 py-2 rounded-full transition shadow-md active:scale-95"
              >
                <LogOut size={16} /> Logout
              </button>
            </div>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white px-5 py-2 rounded-full transition shadow-md active:scale-95"
            >
              <User size={16} /> Staff Login
            </button>
          )}
        </div>

        {/* Mobile Toggle Button */}
        <button
          onClick={toggleMenu}
          className="md:hidden p-2 text-orange-600 transition-all"
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white border-b border-orange-100 animate-in slide-in-from-top duration-300">
          <div className="px-4 pt-2 pb-6 space-y-2">
            <button
              onClick={() => handleNav("/donations")}
              className="flex items-center gap-4 w-full p-4 text-stone-700 font-bold hover:bg-orange-50 rounded-xl transition-colors"
            >
              <Heart size={20} className="text-orange-600" />
              Donations
            </button>

            <button
              onClick={() => handleNav("/about-us")}
              className="flex items-center gap-4 w-full p-4 text-stone-700 font-bold hover:bg-orange-50 rounded-xl transition-colors"
            >
              <HistoryIcon size={20} className="text-orange-600" />
              History
            </button>

            {/* Conditional Logic: Mobile */}
            {isAuthenticated && (
              <button
                onClick={() => handleNav("/dashboard")}
                className="flex items-center gap-4 w-full p-4 text-orange-600 font-bold hover:bg-orange-50 rounded-xl transition-colors"
              >
                <LayoutDashboard size={20} />
                Dashboard
              </button>
            )}

            <div className="pt-2">
              {isAuthenticated ? (
                <button
                  onClick={handleLogout}
                  className="flex items-center justify-center gap-2 w-full bg-orange-700 text-white p-4 rounded-xl font-bold shadow-lg active:scale-95"
                >
                  <LogOut size={20} /> Logout
                </button>
              ) : (
                <button
                  onClick={() => handleNav("/login")}
                  className="flex items-center justify-center gap-2 w-full bg-orange-600 text-white p-4 rounded-xl font-bold shadow-lg active:scale-95"
                >
                  <User size={20} /> Staff Login
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
